import { saveWebPushNotificationsOptionsQuick } from './actions/saveWebPushNotificationsOptions';
import NotificationOptionsFull from './components/NotificationOptionsFull';
import { isWebPushNotificationSupported } from 'owa-webpush-notifications';
import { getOwaWorkload } from 'owa-workloads';
import * as React from 'react';
import { getWebPushNotificationsOption } from './utils/getWebPushNotificationsOption';
import { getLocalWebPushUserSetting } from './utils/getLocalWebPushUserSetting';
var NotificationsOptions = {
    key: 'browserNotifications',
    titleStringKey: 'webpushFullSettingsHeader',
    searchTermsStringKey: 'webpushFullSettingsHeader',
    isHidden: function () {
        return !(getOwaWorkload() == 1 /* Mail */ && isWebPushNotificationSupported(window));
    },
    fullOptionFormSettings: {
        render: function () { return React.createElement(NotificationOptionsFull, null); },
        hideSaveDiscard: function () { return true; },
        isDirty: function () { return false; },
        onSave: Promise.resolve,
        onDiscard: function () { },
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: function () {
                return getWebPushNotificationsOption().enabled && getLocalWebPushUserSetting().enabled;
            },
            onToggle: saveWebPushNotificationsOptionsQuick,
        },
        order: 9 /* DesktopNotifications */,
        workloads: 1 /* Mail */,
    },
};
export default NotificationsOptions;
//# sourceMappingURL=NotificationsOptions.js.map